import { Injectable} from '@angular/core';
import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { Router } from '@angular/router';
import { SessionService } from '../../../core/services/session.service';
import { RouteNames } from '../../../shared/routing/app-routing.constants';
import {  OAuthService } from 'angular-oauth2-oidc';
import { SessionKeys } from '../../../shared/models/SessionKeys';
import { AgTranslateService } from '@ag/vc.ag-core/translate';
import { HelperService } from '../../../shared/services/helper.service';
import { AgAuthenticationService } from '@ag/vc.ag-core/authentication';
@Injectable({
  providedIn: 'root'
})
export class UserAuthenticationService {

  apiUrl: string;

  RouteNames = RouteNames;

  constructor(
    private readonly router: Router,
    private readonly userSession: SessionService,
    private readonly oauthService: OAuthService,
    private agTranslateService: AgTranslateService,
    private helperService: HelperService,
    private readonly authenticationService: AgAuthenticationService
  ) {
    this.apiUrl = AgAppConfigService.get<string>('applicativeApiUrl');
    // this.oauthService.configure(this.userSession.getOauthConfig());
  }


  logout(): void {
    void this.router.navigate(['/' + RouteNames.authentication + '/' + RouteNames.logout]);
  }

  oauthlogout(){
    this.authenticationService.logout(false);
  }
 
  
  public redirectToItsMeAndMSA(): void {
    if (this.agTranslateService.currentLang === 'nl'){
      window.open('https://www.itsme-id.com/nl-BE', '_blank'); 
    }else{
      window.open('https://www.itsme-id.com/fr-BE', '_blank'); 
    }
    this.redirectToMSARegistrationScreen();
  }

  public redirectToMSARegistrationScreen(): void {
    this.clearSession();
    this.oauthlogout();
  }


  clearSession(): void {    
    sessionStorage.removeItem('nonce');
    localStorage.removeItem('uci');
    localStorage.removeItem('personId');
    this.helperService.createSession(SessionKeys.logoutKey, 'true');
    this.userSession.setUserAuthenticationStatus(false);
    localStorage.removeItem('ProcessCd');
    this.userSession.clearChildDetails();
    this.userSession.clearOnlinePaymentInfo();
    this.helperService.clearSession(SessionKeys.isRetryOver);
    this.helperService.clearAllPopupShownFlags();
    this.helperService.clearSession(SessionKeys.isPageReload);
  }

}
